"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomOutputAutoTestStep = void 0;
const base_1 = require("./base");
const utils_1 = require("./utils");
class CustomOutputAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave() {
        const errs = this._checkProgramNotEmpty();
        if (this.data.regex.match(/([^\\]|^)(\\\\)*\\f/) == null) {
            errs.push('The regular expression must contain at least one "\\f"');
        }
        return (0, utils_1.mergeEithers)(this._baseGetDataToSave(), (0, utils_1.errOrData)(errs, { data: this.data, type: this.type }));
    }
}
exports.CustomOutputAutoTestStep = CustomOutputAutoTestStep;
